var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"has-fixed-header"},[_c('div',{staticClass:"container is-fluid"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }